<template>
    <div id="page" class="page-content">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Certificado de Mantención OT {{ idcotizacionvehiculo }}</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
        </div>

        <div class="content-boxed">

            <div class="content bottom-0">
                <iframe class="caption caption-margins round-medium shadow-large" width="98%" height="600px"
                    :src="getIframeSrc()" frameborder="0"></iframe>


                <form onsubmit="event.preventDefault();" class="contactForm" id="FormsubmitFecha">
                    <table width='100%' class="bg-gray1-dark">
                        <tr>
                            <td class="row bg-gray1-dark" style="display: flex ; justify-content: center;">
                                <div style="text-align: right">
                                    <VueSignaturePad id="signature" width="513px" height="100px" ref="signaturePad" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td width='20%' class="row bg-gray1-dark">
                                <div class="col-3 mt-2">
                                    <button @click="undoimage"
                                        class="button button-s shadow-small button-circle bg-dark1-dark">
                                        <i class="fa fa-times"></i>
                                        Limpiar firma
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </form>

                <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
                        <div class="content-boxed">
                            <a href="#"
                                class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton"
                                @click="siguiente(idcotizacionvehiculo, idExterno)" data-formId="dataForm">Siguiente</a>
                        </div>
                    </form>
                </div>

            </div>

        </div>

    </div>
</template>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/FirmaCertificadoMantencion.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:100% 100%;
  background-origin: border-box;
  background-clip: content-box, border-box;
  background-repeat: no-repeat;
}
</style>

<script>
    import * as db from "../../database.js";
    import * as validate from "../../validate.js";

    import VueSignaturePad from 'vue-signature-pad';

    export default{
        data(){
            return{
                params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculoCertificadoMantencion')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
                idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculoCertificadoMantencion'),
                idExterno: localStorage.getItem('idExternoCertificadoMantencion'),
                KilometrajeSalida: null,

                OT:{
                    codvehiculo:0,
                    marca:"",
                    modelo:"",
                    version:"",
                    agno:"",
                    placapatente:"",
                    vin:"",

                    kilometraje:0,
                    datatipoot:"",
                    datatipotrabajo:"",
                    fechaentrega:"",
                    horaentrega:"" ,  
                    fechaentregaotasesor:"", 
                    KilometrajeSalida:0
                }
            }
        },

        created(){
            this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")" 
        },

        mounted(){
        },

        computed: {
        },

        methods:{
            undoimage() 
            {
                this.$refs.signaturePad.clearSignature();
            },

            undo() 
            {
                alert('undo');
                this.$refs.signaturePad.undoSignature();
            },

            getIframeSrc() {

                // Carpeta del reporte por cliente desde config.json
                return db.getReportBase()+"tlrShowCertificadoMantencion.aspx?id="+this.idExterno+'&t='+new Date().getTime(); // anti-cache
            },

            siguiente(idcotizacionvehiculo, idExterno)
            {

                // this.paramsvehiculo = '{"valkey":"' + this.OT.codvehiculo + '","tablename":"T_VEH_VEHICULO"}';

                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                if (data != null) {

                    db.getFx2("ot.saveimageFirmCertificadoMantencion", '{"idcotizacionvehiculo":"' + this.idcotizacionvehiculo + '","data":"' + data + '"}').then(result => {
                        if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); } else {
                            const paginaAnterior = localStorage.getItem("PaginaVolver") || "/MisOT";

                            window.open(this.getIframeSrc(), '_blank');

                            window.location = paginaAnterior
                        }
                    });
                    
                } else {
                    const paginaAnterior = localStorage.getItem("PaginaVolver") || "/MisOT";
                    window.location = paginaAnterior
                }
                
            }
        }
    }

</script>